import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import { global } from "@shared/libs/Global";
import { getInitPopUpData } from "@shared/utils/CommonUtils";
import { fnGetDataSet } from "@shared/api/restApi";
import SearchPanel from "@widgets/SearchPanel";
import { SnSearchBtn } from "@shared/components/SnSearchBtn";
import { SnTab } from "@shared/components/SnTab";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { showDialog } from "@widgets/CommonDialog";

interface popupProps {
  selectedData?: any;
  modalRef?: any;
}

const SN_MTL_SCT_REG_002_POP_001 = forwardRef(
  ({ selectedData, modalRef }: popupProps, ref: React.Ref<any>) => {
    const { userInfo } = global();

    const searchRef = useRef<any>(null);
    const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
      grid1: React.createRef(),
      grid2: React.createRef(),
      grid3: React.createRef(),
      grid4: React.createRef(),
    });

    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);
    const [columns, setColums] = useState<any>({
      grid1: [],
      grid2: [],
      grid3: [],
      grid4: [],
    });
    const [dataSources, setDataSources] = useState<any>({
      grid1: [],
      grid2: [],
      grid3: [],
      grid4: [],
    });

    const [qtio2, setQtio2] = useState<any[]>([]);
    const [selectedTabPage, setTapPage] = useState<string>("1");
    const [popupParent, setPopupParent] = useState<any>(null);

    useImperativeHandle(ref, () => ({
      checkValidity: async () => {
        let selectedHeader: any[] =
          gridRefs.current["grid1"].current?.getCheckedRows();

        let isSameCust: boolean = false;
        if (selectedHeader && selectedHeader.length > 0) {
          const cdCustValue = selectedHeader[0].cd_cust;
          isSameCust = selectedHeader.every(
            (item: any) => item.cd_cust === cdCustValue
          );
        } else {
          return true;
        }

        if (!isSameCust) {
          await showDialog("alter", "외주처가 동일한 건만 적용 가능합니다.");
          return false;
        } else {
          return true;
        }
      },
      getOkayData: () => {
        let result;
        const filteredQtio2List = qtio2ByKeys();
        if (selectedTabPage === "1") {
          result = [
            gridRefs.current["grid1"].current?.getSelectedRows() || [],
            gridRefs.current["grid2"].current?.getSelectedRows() || [],
            filteredQtio2List,
          ];
        } else {
          result = [
            gridRefs.current["grid3"].current?.getSelectedRows() || [],
            gridRefs.current["grid4"].current?.getSelectedRows() || [],
            filteredQtio2List,
          ];
        }
        return {
          rtnData: result,
        };
      },
    }));

    useEffect(() => {
      if (modalRef?.current) {
        setPopupParent(modalRef.current.getPopupParent());
      }
    }, [modalRef?.current]);

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUpData(
            "SN_MTL_SCT_REG_002_POP_001",
            {}
          );
          const mergedData: any = { ...rtn.formData, ...selectedData };
          setFormControlData(rtn.formControlData);
          setFormData(mergedData);
          setColums({
            grid1: rtn.grid.grid1,
            grid2: rtn.grid.grid2,
            grid3: rtn.grid.grid3,
            grid4: rtn.grid.grid4,
          });
        } catch (error) {}
      };
      fetchform();
    }, []);

    const onSearch = async () => {
      try {
        const param = {
          id: "sn_mtl_sct_reg_002_pop_01",
          params: searchRef.current.getFormdata(),
        };
        gridRefs.current["grid1"].current.resetUpdate();
        gridRefs.current["grid2"].current.resetUpdate();
        gridRefs.current["grid3"].current.resetUpdate();
        gridRefs.current["grid4"].current.resetUpdate();
        const data: any = await fnGetDataSet(param);
        setDataSources({
          grid1: data[0] || [],
          grid2: data[1] || [],
          grid3: data[2] || [],
          grid4: data[3] || [],
        });
        setQtio2(data[4]);
      } catch (error: any) {}
    };

    const onTabChanged = (index: string) => {
      setTapPage(index);
    };

    const onCheckedRowChaged1 = (
      value: boolean,
      type: "row" | "header" = "row"
    ) => {
      if (type === "header") {
        gridRefs.current["grid2"].current.setCheckedAll(value);
      } else {
        gridRefs.current["grid2"].current.setCheckedAllWithFilter(value);
      }
    };

    const onCheckedRowChaged2 = (value: boolean) => {
      const checkdRows =
        gridRefs.current["grid2"].current.getCheckedFilteredRows();
      if (checkdRows.length > 0)
        gridRefs.current["grid1"].current.setCheckedFocusedRow(true, "noEvent");
      else
        gridRefs.current["grid1"].current.setCheckedFocusedRow(
          false,
          "noEvent"
        );
    };

    const onCheckedRowChaged3 = (
      value: boolean,
      type: "row" | "header" = "row"
    ) => {
      if (type === "header") {
        gridRefs.current["grid4"].current.setCheckedAll(value);
      } else {
        gridRefs.current["grid4"].current.setCheckedAllWithFilter(value);
      }
    };

    const onCheckedRowChaged4 = (value: boolean) => {
      const checkdRows =
        gridRefs.current["grid4"].current.getCheckedFilteredRows();
      if (checkdRows.length > 0)
        gridRefs.current["grid3"].current.setCheckedFocusedRow(true, "noEvent");
      else
        gridRefs.current["grid3"].current.setCheckedFocusedRow(
          false,
          "noEvent"
        );
    };

    const qtio2ByKeys = (): any[] => {
      let selectedRows: any[] = [];
      if (selectedTabPage === "1") {
        selectedRows = gridRefs.current["grid2"].current.getSelectedRows();
      } else {
        selectedRows = gridRefs.current["grid4"].current.getSelectedRows();
      }
      if (!selectedRows?.length || !qtio2?.length) return [];

      const selectedMap = new Map<string, any>();
      selectedRows.forEach((s) => {
        const key = `${s.no_req}|${s.no_line}|${s.no_po}|${s.no_line_po}`;
        selectedMap.set(key, s.qt_app);
      });

      return qtio2
        .filter((q) => {
          const key = `${q.no_req}|${q.no_line}|${q.no_po}|${q.no_line_po}`;
          return selectedMap.has(key);
        })
        .map((q) => {
          const key = `${q.no_req}|${q.no_line}|${q.no_po}|${q.no_line_po}`;
          return {
            ...q,
            qt_app: selectedMap.get(key),
          };
        });
    };

    const grids = useMemo(
      () => ({
        grid1: {
          columns: columns.grid1,
          dataSource: dataSources.grid1,
          events: {
            onCheckedRowChaged: onCheckedRowChaged1,
          },
        },
        grid2: {
          columns: columns.grid2,
          dataSource: dataSources.grid2,
          events: {
            onCheckedRowChaged: onCheckedRowChaged2,
          },
        },
        grid3: {
          columns: columns.grid3,
          dataSource: dataSources.grid3,
          events: {
            onCheckedRowChaged: onCheckedRowChaged3,
          },
        },
        grid4: {
          columns: columns.grid4,
          dataSource: dataSources.grid4,
          events: { onCheckedRowChaged: onCheckedRowChaged4 },
        },
      }),
      [columns, dataSources]
    );

    return (
      <div className="h-full flex flex-col">
        <div>
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            popupRef={ref}
          ></SearchPanel>
        </div>
        <div className="mb-2" style={{ textAlign: "center" }}>
          <SnSearchBtn
            text={"조회"}
            onClick={onSearch}
            sx={{ width: 80, marginTop: 1.5 }}
            spinner={true}
          />
        </div>

        <div className="flex-1">
          <SnTab
            titles={["의뢰번호별", "외주처별"]}
            onTabChanged={onTabChanged}
            body={[
              <div className="flex flex-col w-full h-full min-h-0 space-y-1.5">
                <SnGrid
                  ref={gridRefs.current["grid1"]}
                  columnConfig={grids.grid1.columns}
                  rowData={grids.grid1.dataSource}
                  etcProps={{
                    rowSelection: "single",
                    popupParent: popupParent,
                  }}
                  events={grids.grid1.events}
                  filter={{
                    refs: [gridRefs.current["grid2"]],
                    columns: ["no_req"],
                  }}
                />
                <SnGrid
                  ref={gridRefs.current["grid2"]}
                  columnConfig={grids.grid2.columns}
                  rowData={grids.grid2.dataSource}
                  etcProps={{
                    rowSelection: "multiple",
                    popupParent: popupParent,
                  }}
                  events={grids.grid2.events}
                />
              </div>,
              <div className="flex flex-row w-full h-full min-w-0 space-x-1.5">
                <div className="basis-1/3 shrink-0 min-w-0">
                  <SnGrid
                    ref={gridRefs.current["grid3"]}
                    columnConfig={grids.grid3.columns}
                    rowData={grids.grid3.dataSource}
                    etcProps={{
                      rowSelection: "single",
                      popupParent: popupParent,
                    }}
                    events={grids.grid3.events}
                    filter={{
                      refs: [gridRefs.current["grid4"]],
                      columns: ["cd_cust"],
                    }}
                  />
                </div>
                <div className="basis-2/3 shrink-0 min-w-0">
                  <SnGrid
                    ref={gridRefs.current["grid4"]}
                    columnConfig={grids.grid4.columns}
                    rowData={grids.grid4.dataSource}
                    etcProps={{
                      rowSelection: "multiple",
                      popupParent: popupParent,
                    }}
                    events={grids.grid4.events}
                  />
                </div>
              </div>,
            ]}
          />
        </div>
      </div>
    );
  }
);

export default SN_MTL_SCT_REG_002_POP_001;
